import script from "./ModalGallery.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModalGallery.vue?vue&type=script&lang=ts&setup=true"

import "./ModalGallery.vue?vue&type=style&index=0&id=17204277&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17204277"]])

export default __exports__